import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton, FilterBar, TableData } from '../../../components';
import { confirmAlert, errorAlert } from '../../../helpers/alerts';
import { createMultipleCommerceService, getCommercesService } from '../../../services/client/commerceService';
import { setCommerces } from '../../../redux/slices/client/commerceSlice';
import { Box } from '@mui/material';
import FileInput from 'components/common/FileInput';
import { AddTask, FileDownload } from '@mui/icons-material';
import { downloadStaticFile } from 'helpers/util';
import readXlsxFile from 'read-excel-file'
import { setLoading } from 'redux/slices/uiSlice';

const ImportCommerceScreen = () => {
  const dispatch = useDispatch();
  const { commerces } = useSelector((store) => store.commerces);
  const [list, setList] = useState([])
  const [commerce, setCommerce] = useState(null)

  useEffect(() => {
    getCommercesService(undefined, true)
      .then((response) => dispatch(setCommerces(response.filter(c => ['DISTRIBUIDOR'].includes(c.type_commerce)))))
      .catch((e) => errorAlert(e))
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = (data) => {
    setCommerce(data.commerce)
  }

  const handlerCreate = () => {
    dispatch(setLoading(true));
    createMultipleCommerceService({ list, commerce }).then(() => {
      setList([]);
      confirmAlert({
        title: "¡Los comercios se han creado exitosamente! ",
        icon: 'success',
        showCancelButton: false,
      });
    }).catch((e) => errorAlert(e))
      .finally(() => dispatch(setLoading(false)));
  }

  const handlerFile = (file) => {
    if (!file) return;
    if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return
    readXlsxFile(file).then((rows) => {
      setList(rows.filter((_, index) => index > 1).map((row) => ({
        //commerce
        commerce_name: row[0],
        name: row[1],
        type_commerce: row[2],
        user_commerce: row[3],
        password: row[4],
        //bag
        type_bag: [
          row[5] ? 'TAE' : null,
          row[6] ? 'PDS' : null,
        ].filter(Boolean),
        earnings_scheme: row[7],
        billing_mode: row[8],
        //sale point
        type_salepoint: [
          row[9] ? 'Portal Web' : null,
          row[10] ? 'Aplicación Móvil' : null,
          row[11] ? 'Web Service' : null,
        ].filter(Boolean),
        days: [
          row[12] ? 'monday' : null,
          row[13] ? 'tuesday' : null,
          row[14] ? 'wednesday' : null,
          row[15] ? 'thursday' : null,
          row[16] ? 'friday' : null,
          row[17] ? 'saturday' : null,
          row[18] ? 'sunday' : null,
        ].filter(Boolean),
      })));
    });
  }

  const handlerDownload = () => {
    downloadStaticFile('/templates/Plantilla_Comercio.xlsx', 'Plantilla_Comercio.xlsx');
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        showTitle={false}
        filters={[
          {
            name: 'commerce',
            label: "Comercio",
            type: "select",
            data: commerces.map(({ _id: id, username }) => ({ id, name: username }))
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          headerButtons={[
            <CustomButton
              icon={<FileDownload />}
              key="dowloadDetails"
              name={"Plantilla"}
              click={handlerDownload}
            />,
            <FileInput
              dark={true}

              key="addCommerce"
              name={"Cargar archivo"}
              onChange={handlerFile}
            />,
            list.length > 0 && <CustomButton
              dark={true}
              icon={<AddTask />}
              key="dowloadDetails"
              name={"Crear"}
              click={handlerCreate}
            />,
          ]}
          dataRows={list}
          dataTitle={[
            "Nombre",
            "Tipo",
            "Bolsa",
            "Usuario",
            "Contraseña",
          ]}
          formatter={({ commerce_name, password, type_commerce, type_bag, user_commerce }) => [
            commerce_name,
            type_commerce,
            type_bag ? Array.isArray(type_bag) ? type_bag.join(', ') : type_bag : '',
            user_commerce,
            password,
          ]}
        />
      </Box>
    </>
  )
}

export default ImportCommerceScreen